import { AddressMessage } from './AddressMessage';
import { MailSettings } from './MailSettings';
import { SupplierGroupSubscriptionMessage } from './SupplierGroupSubscriptionMessage';

export enum SupplierGroupTypes {
    TRADER = 'TRADER',
    BROKER = 'BROKER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    MANUFACTURER = 'MANUFACTURER',
}

export interface EditSupplierGroupRequestMessage {
    id: string;
    name: string;
    email?: string;
    phone?: string;
    fax?: string;
    address?: AddressMessage;
    description?: string;
    gtcUrl?: string;
    headquarter?: string;
    testCompany: boolean;
    emailQuote: boolean;
    anonymousQuote: boolean;
    supplierProductGroups?: string[];
    translationSupplierProductGroup?: string;
    type: SupplierGroupTypes;
    lubesSettings: SpotSettings;
    mailSettings: MailSettings;
}

export interface CreateSupplierGroupRequestMessage {
    name: string;
    phone?: string;
    fax?: string;
    address?: AddressMessage;
    description?: string;
    gtcUrl?: string;
    headquarter?: string;
    testCompany: boolean;
    emailQuote: boolean;
    anonymousQuote: boolean;
    supplierProductGroups?: string[];
    translationSupplierProductGroup?: string;
    type: SupplierGroupTypes;
}

export interface SpotSettings {
    spotAllowed: boolean;
    spotSupplierId?: string;
    availabilityCountryCodes: string[];
}

export interface SupplierGroupMessage {
    subscription?: SupplierGroupSubscriptionMessage;
    id: string;
    name: string;
    type: SupplierGroupTypes;
    dateCreated: number;
    dateUpdated?: number;
    testCompany: boolean;
    spotAllowed: boolean;
    anonymousQuote: boolean;
    logo?: {
        url: string;
        thumbUrl: string;
    };
    address?: AddressMessage;
    phone?: string;
    fax?: string;
    email?: string;
    supplierProductGroups?: string[];
    translationSupplierProductGroup?: string;
    headquarter?: string;
    description?: string;
    gtcUrl?: string;
    gtcAccepted: boolean;
    trial: boolean;
    emailQuote: boolean;
    mailSettings: MailSettings;
    lubesSettings: SpotSettings;
}
